import RenderManager from "./render-manager";

class WebVrWrapper {

    constructor(renderer, autoActivate = false) {

        //Props
        this._supportsWebVr = false;
        this._isActive = false;
        this._displays = [];
        this._currentDisplay = null;

        //Refs
        this._renderer = renderer;
        this._renderTarget = null;
        this._prevCamPosition = null;

        //THREE.VREffect
        this.vrEffect = null;
        this.vrControls = null;
        this._vrRequestFrame = null;

        //DOM btn
        this.btnToggle = null;

        //Init
        this._init(autoActivate);

    }

    get supportsWebVr() {

        return this._supportsWebVr;

    }

    get active() {

        return this._isActive;

    }

    set active(v) {

        let newActiveState = !!v;

        if (!this.supportsWebVr || newActiveState === this._isActive) {

            return;

        }

        let display = this._currentDisplay; //TODO: check if a handset can launch this method externally (a device button...). Look for event
        let camera = RenderManager.activeCamera;
        let scene = RenderManager.activeScene;
        let orbitControls = Q3.controls;
        let vrControls = this.vrControls;

        this._isActive = newActiveState;

        if (newActiveState) {

            this.vrEffect.requestPresent([{ source: this._renderer.domElement }]);

            orbitControls.enabled = false;
            vrControls.enabled = true;
            this._vrRequestFrame();

        } else {

            this.vrEffect.exitPresent();

            orbitControls.enabled = true;
            vrControls.enabled = false;

        }

        camera.update = true;

    }

    /**
     * Initializes the class
     * @param {Booean} autoActivate if true, it starts VR mode
     */
    _init(autoActivate = false) {

        try {
            const that = this;

            if (!Q3.editMode && navigator && 'getVRDisplays' in navigator) {

                navigator.getVRDisplays().then(displays => {

                    if (displays.length) {

                        var size = that._renderer.getSize();

                        that._supportsWebVr = true;
                        that._displays = displays;

                        that.vrEffect = new THREE.VREffect(this._renderer);
                        that.vrControls = new THREE.VRControls(RenderManager.activeCamera);
                        that.vrControls.enabled = false;

                        that._vrRequestFrame = () => {

                            RenderManager.activeCamera.update = true;
                            if (that._isActive) { requestAnimationFrame(that._vrRequestFrame); }

                        };

                        that._renderTarget = new THREE.WebGLRenderTarget(size.width, size.height,
                            { minFilter: THREE.LinearFilter, magFilter: THREE.NearestFilter, format: THREE.RGBAFormat }
                        );

                        that.activateButton();

                        that.active = autoActivate;

                    }

      }).catch(e=>console.error(e));

            }
        } catch (e) { console.error(e); }

    }

    /**
     * Make button active
     */
    activateButton() {

        this.btnToggle = document.getElementById('qbix-viewer-button-webvr');

        if (!this.btnToggle) {

            return;

        }

        const toggle = () => {

            this.active = !this.active;

        }

        this.btnToggle.style.display = 'inline-block';
        this.btnToggle.addEventListener('click', toggle, false);

    }

    /**
     * Renders
     * @param {THREE.Scene} scene Scene
     * @param {THREE.PerspectiveCamera} camera Camera
     */
    render(scene, camera, renderTarget, forceClear) {

        this.vrControls.update();
        this.vrEffect.render(scene, camera, renderTarget, forceClear);

    }

}

export default WebVrWrapper;
export { WebVrWrapper };

